import React, { Component } from 'react';
import './Doors.css';
import QuoteForm from '../QuoteForm/QuoteForm';
import StyleCard from '../StyleCards/StyleCard';
import slidingPatio from '../../Assets/windowStyles/slidingPatio.jpg';
import frenchDoor from '../../Assets/windowStyles/frenchDoor.png';
import { BrowserRouter as Router, Routes,Route } from 'react-router-dom';


class Doors extends Component {
  render() {
  return (
    <div class='doorMain'>
      <div class='doorHeader'>
        <h1 class="doorTitle">
          Doors
        </h1>
      </div>
      <div class="visionSect">
         <h2>Door Replacements</h2>
         <div class="vision">
          Our Vision at DNS Home Exteriors has always been to set a new standard of excellence for contractors that raises the bar when it comes to first-class customer service, industry knowledge, and craftsmanship.
         </div>
      </div>
      <hr></hr>
      <div class="doorInfoSect">
        <section class="doorInfo">
          <div>
          <h4>It's time to replace your Doors</h4>
          <p>Replacing your doors can significantly enhance both the security and energy
           efficiency of your home. Over time, old doors may become warped, cracked,
            or poorly sealed, making them easier to force open and less effective at
            keeping out the elements. Upgrading to a new door with modern locking
             mechanisms and better insulation materials not only improves safety
             but also helps reduce energy bills by maintaining a more consistent indoor temperature.
          <br></br>
          <br></br>
    In addition to functional benefits, replacing your doors can also boost your
    home's curb appeal and value. A stylish, updated front door makes a strong first
    impression and reflects the overall upkeep of your property. Whether you're looking
    to sell or simply want a fresh look, modern doors come in a variety of designs and
    finishes to complement your home's architecture and personal style.</p>
          </div>
        </section>
        <section class="quotoForm">
          <QuoteForm />
        </section>
      </div>
    <div class="sectionSpacer">
       <h2>Available Replacement Door Options</h2>
    </div>
    <div class="replacementOptionsDoors">
      <StyleCard
        image={slidingPatio}
        title="Sliding Patio"
        description=""
        />
        <StyleCard
          image={frenchDoor}
          title="French Patio"
          description=""
          />
    </div >

  </div>
  )
};
}

export default Doors;
